import { Entity, Index, OneToMany } from 'typeorm';
import { Column } from '../../decorators';
import { BaseEntity } from './base.entity';
import { OrderEntity } from './order.entity';
import { ShippingMethodCompanyEntity } from './shipping-method-company.entity';
import { ShippingMethodRestrictionEntity } from './shipping-method-restriction.entity';

@Index('shipping_method_externalId_idx', ['externalId'])
@Entity('shipping_method')
export class ShippingMethodEntity extends BaseEntity {
	@Column('varchar', { name: 'label', length: 255 })
	public label!: string;

	/** Public-facing description shown to users during checkout */
	@Column('text', { name: 'description', nullable: true })
	public description!: string | null;

	/** Internal description for administrative reference — not shown during checkout */
	@Column('text', { name: 'internalDescription', nullable: true })
	public internalDescription!: string | null;

	@Column('decimal', {
		name: 'fee',
		precision: 13,
		scale: 2,
		default: () => "'0.00'",
	})
	public fee!: string;

	@Column('decimal', {
		name: 'freeShippingThreshold',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public freeShippingThreshold!: string | null;

	@Column('varchar', { name: 'externalId', nullable: true, length: 64 })
	public externalId!: string | null;

	@Column('tinyint', {
		name: 'isAvailableInCrm',
		width: 1,
		default: () => "'1'",
	})
	public isAvailableInCrm!: boolean;

	@Column('tinyint', {
		name: 'isAvailableInEcommerce',
		width: 1,
		default: () => "'1'",
	})
	public isAvailableInEcommerce!: boolean;

	@Column('tinyint', { name: 'isActive', width: 1, default: () => "'1'" })
	public isActive!: boolean;

	/** When true, this method is hidden from checkout if restrictions make it unavailable (instead of shown as disabled) */
	@Column('tinyint', {
		name: 'hideWhenNotAllowed',
		width: 1,
		default: () => "'0'",
	})
	public hideWhenNotAllowed!: boolean;

	@Column('int', { name: 'sortOrder', nullable: true })
	public sortOrder!: number | null;

	@OneToMany(() => ShippingMethodCompanyEntity, (smc) => smc.shippingMethod)
	public companies!: Array<ShippingMethodCompanyEntity>;

	@OneToMany(() => ShippingMethodRestrictionEntity, (smr) => smr.shippingMethod)
	public restrictions!: Array<ShippingMethodRestrictionEntity>;

	@OneToMany(() => OrderEntity, (order) => order.shippingMethod)
	public orders!: Array<OrderEntity>;
}
